import { Component, EventEmitter, Injector, Output , Input, OnInit } from '@angular/core';
import { filter, finalize } from 'rxjs/operators';
import { FindProductOutputDto, SearchProductInput } from '@shared/service-proxies/service-proxies';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import {
  CommonLookupServiceProxy
} from '@shared/service-proxies/service-proxies';
import { appModuleAnimation } from '@shared/animations/routerTransition';
@Component({
  selector: 'app-search-product',
  templateUrl: './search-product.component.html',
  styleUrl: './search-product.component.css',
  standalone: false,
})

export class SearchProductComponent  {
  @Input() productSelectedItem: FindProductOutputDto;   
  @Output() productEvent = new EventEmitter<FindProductOutputDto>();
  products: FindProductOutputDto[];
  /*productSelectedItem: FindProductOutputDto;*/
  filterText = '';

  constructor(
    private _commonLookupServiceProxy: CommonLookupServiceProxy
  ) {
      
  }


  filterProducts(event: AutoCompleteCompleteEvent) {
    this.filterText = event.query.toLowerCase();
    this.getProducts();
  }

  onProductSelected(event: any) {
    this.productEvent.emit(event.value);
  }


    getProducts() {

        var input = new SearchProductInput();
        input.filter = this.filterText;
        this._commonLookupServiceProxy
            .searchProduct(input)
        .subscribe((result) => {
            console.log(result);
        this.products = result;
      });
  }

}
